import React, { forwardRef } from 'react';
import { RadioGroup, Text } from 'rsuite';
import AnnotatedRadio from './AnnotatedRadio';
import { isNullUndefinedOrEmptyString } from '../../common/utils';

export interface RadioGroupWithErrorStatusProps {
  onChange: (value: any) => void;
  options: any[];
  defaultOption: any;
  disabled?: boolean;
}

export const RadioGroupWithErrorStatus = React.memo(
  forwardRef<HTMLDivElement, RadioGroupWithErrorStatusProps>(
    ({ onChange, options, defaultOption, disabled }, ref) => {
      return (
        <RadioGroup
          ref={ref}
          onChange={onChange}
          value={defaultOption?.key}
        >
          {options?.map((opt, idx) => {
            const hasAnnotationText = !isNullUndefinedOrEmptyString(
              opt.description
            );
            const optionKey = opt.key;
            return (
              <AnnotatedRadio
                key={`radio_option_${optionKey}_${idx}`}
                value={optionKey}
                label={`${opt.label}`}
                annotation={() =>
                  hasAnnotationText ? <Text>{opt.description}</Text> : null
                }
                disabled={disabled}
              />
            );
          })}
        </RadioGroup>
      );
    }
  )
);
